// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Common = require("../utils/Common.bs.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var MM_context = require("../mm-utils/MM_context.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var MM_wrk_editor = require("../worker/MM_wrk_editor.bs.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.bs.js");
var MM_react_common = require("../ui-utils/MM_react_common.bs.js");
var MM_cmp_user_stmt = require("../ui/MM_cmp_user_stmt.bs.js");
var Belt_HashMapString = require("rescript/lib/js/belt_HashMapString.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.bs.js");
var Expln_utils_promise = require("../../rescript-utils/main/Expln_utils_promise.bs.js");
var Button = require("@mui/material/Button").default;
var ButtonGroup = require("@mui/material/ButtonGroup").default;
var Search = require("@mui/icons-material/Search").default;
var ZoomInMap = require("@mui/icons-material/ZoomInMap").default;
var ZoomOutMap = require("@mui/icons-material/ZoomOutMap").default;
var ContentCopy = require("@mui/icons-material/ContentCopy").default;
var CancelOutlined = require("@mui/icons-material/CancelOutlined").default;

function makeInitialState(ctx, stmt, symColors) {
  var syms = MM_context.ctxIntsToSymsExn(ctx, stmt);
  return {
          cont: {
            TAG: /* Text */0,
            text: syms.join(" "),
            syms: syms.map(function (sym) {
                  return {
                          sym: sym,
                          color: Belt_HashMapString.get(symColors, sym)
                        };
                })
          }
        };
}

function propsAreSame(a, b) {
  if (a.ctx === b.ctx && a.stmt === b.stmt && a.symColors === b.symColors && a.symRename === b.symRename) {
    return a.editStmtsByLeftClick === b.editStmtsByLeftClick;
  } else {
    return false;
  }
}

var make = React.memo((function (param) {
        var openExplorer = param.openExplorer;
        var symRename = param.symRename;
        var symColors = param.symColors;
        var stmt = param.stmt;
        var parenCnt = param.parenCnt;
        var frameRestrict = param.frameRestrict;
        var frms = param.frms;
        var syntaxTypes = param.syntaxTypes;
        var ctx = param.ctx;
        var modalRef = param.modalRef;
        var match = React.useState(function () {
              return makeInitialState(ctx, stmt, symColors);
            });
        var setState = match[1];
        var state = match[0];
        var match$1 = React.useState(function () {
              
            });
        var setSyntaxTreeWasRequested = match$1[1];
        var syntaxTreeWasRequested = match$1[0];
        var match$2 = React.useState(function () {
              
            });
        var setSyntaxTreeError = match$2[1];
        var syntaxTreeError = match$2[0];
        var match$3 = React.useState(function () {
              
            });
        var setCopiedToClipboard = match$3[1];
        var copiedToClipboard = match$3[0];
        React.useEffect((function () {
                Curry._1(setState, (function (param) {
                        return makeInitialState(ctx, stmt, symColors);
                      }));
              }), [
              ctx,
              stmt,
              symColors,
              symRename,
              param.editStmtsByLeftClick
            ]);
        React.useEffect((function () {
                if (syntaxTreeError !== undefined) {
                  Curry._1(setSyntaxTreeError, (function (param) {
                          
                        }));
                  MM_react_common.openInfoDialog(modalRef, syntaxTreeError, undefined, undefined, undefined);
                }
                
              }), [syntaxTreeError]);
        var actUpdateSyntaxTree = function (update) {
          var treeData = state.cont;
          if (treeData.TAG === /* Text */0) {
            return ;
          }
          var newCont = {
            TAG: /* Tree */1,
            _0: Curry._1(update, treeData._0)
          };
          Curry._1(setState, (function (param) {
                  return {
                          cont: newCont
                        };
                }));
        };
        var actTreeNodeClicked = function (nodeId) {
          actUpdateSyntaxTree(function (treeData) {
                return MM_wrk_editor.incExpLvlIfConstClicked({
                            text: treeData.text,
                            exprTyp: treeData.exprTyp,
                            root: treeData.root,
                            clickedNodeId: [
                              nodeId,
                              new Date()
                            ],
                            expLvl: 0
                          });
              });
        };
        var actUnselect = function (param) {
          actUpdateSyntaxTree(function (treeData) {
                return {
                        text: treeData.text,
                        exprTyp: treeData.exprTyp,
                        root: treeData.root,
                        clickedNodeId: undefined,
                        expLvl: treeData.expLvl
                      };
              });
        };
        var actExpandSelection = function (param) {
          actUpdateSyntaxTree(function (__x) {
                return MM_wrk_editor.updateExpLevel(__x, true);
              });
        };
        var actShrinkSelection = function (param) {
          actUpdateSyntaxTree(function (__x) {
                return MM_wrk_editor.updateExpLevel(__x, false);
              });
        };
        React.useEffect((function () {
                if (syntaxTreeWasRequested !== undefined) {
                  Common.$$setTimeout((function (param) {
                          Curry._1(setSyntaxTreeWasRequested, (function (param) {
                                  
                                }));
                          var match = state.cont;
                          if (match.TAG !== /* Text */0) {
                            return Curry._1(setSyntaxTreeError, (function (param) {
                                          return "Cannot build a syntax tree because stmtCont is a tree.";
                                        }));
                          }
                          var syms = match.syms;
                          var msg = MM_wrk_editor.textToSyntaxTree(ctx, [syms.map(function (s) {
                                        return s.sym;
                                      }).slice(1)], syntaxTypes, frms, frameRestrict, parenCnt, MM_cmp_user_stmt.getLastSyntaxType(undefined), MM_cmp_user_stmt.setLastSyntaxType);
                          if (msg.TAG === /* Ok */0) {
                            var msg$1 = Caml_array.get(msg._0, 0);
                            if (msg$1.TAG === /* Ok */0) {
                              var syntaxTree = msg$1._0;
                              var stmtContTreeData_text = match.text;
                              var stmtContTreeData_exprTyp = Caml_array.get(syms, 0).sym;
                              var stmtContTreeData_root = MM_wrk_editor.addColorsToSyntaxTree(syntaxTree, Caml_option.some(symColors), undefined, undefined);
                              var stmtContTreeData_clickedNodeId = Belt_Option.map(MM_wrk_editor.getNodeIdBySymIdx(syntaxTreeWasRequested, syntaxTree), (function (id) {
                                      return [
                                              id,
                                              new Date()
                                            ];
                                    }));
                              var stmtContTreeData = {
                                text: stmtContTreeData_text,
                                exprTyp: stmtContTreeData_exprTyp,
                                root: stmtContTreeData_root,
                                clickedNodeId: stmtContTreeData_clickedNodeId,
                                expLvl: 0
                              };
                              var newCont = {
                                TAG: /* Tree */1,
                                _0: MM_wrk_editor.incExpLvlIfConstClicked(stmtContTreeData)
                              };
                              return Curry._1(setState, (function (param) {
                                            return {
                                                    cont: newCont
                                                  };
                                          }));
                            }
                            var msg$2 = msg$1._0;
                            return Curry._1(setSyntaxTreeError, (function (param) {
                                          return msg$2;
                                        }));
                          }
                          var msg$3 = msg._0;
                          Curry._1(setSyntaxTreeError, (function (param) {
                                  return msg$3;
                                }));
                        }), 10);
                }
                
              }), [syntaxTreeWasRequested]);
        var rndSelectionButtons = function (param) {
          var match = state.cont;
          var clickedTimeStr;
          if (match.TAG === /* Text */0) {
            clickedTimeStr = "1";
          } else {
            var match$1 = match._0.clickedNodeId;
            clickedTimeStr = match$1 !== undefined ? match$1[1].toISOString() : "1";
          }
          var partial_arg = MM_react_common.kbrdClbkMake(MM_react_common.keyEsc, undefined, undefined, undefined, actUnselect, undefined);
          var partial_arg$1 = MM_react_common.kbrdClbkMake("s", undefined, undefined, undefined, actShrinkSelection, undefined);
          var partial_arg$2 = MM_react_common.kbrdClbkMake("w", undefined, undefined, undefined, actExpandSelection, undefined);
          return React.createElement(Expln_React_Row.make, {
                      alignItems: "center",
                      children: Caml_option.some(null)
                    }, React.createElement(ButtonGroup, {
                          variant: "outlined",
                          size: "small",
                          children: null
                        }, React.createElement(Button, {
                              onClick: (function (param) {
                                  actUpdateSyntaxTree(function (__x) {
                                        return MM_wrk_editor.updateExpLevel(__x, true);
                                      });
                                }),
                              title: "Expand selection, W",
                              children: Caml_option.some(React.createElement(ZoomOutMap, {}))
                            }), React.createElement(Button, {
                              onClick: (function (param) {
                                  actUpdateSyntaxTree(function (__x) {
                                        return MM_wrk_editor.updateExpLevel(__x, false);
                                      });
                                }),
                              title: "Shrink selection, S",
                              children: Caml_option.some(React.createElement(ZoomInMap, {}))
                            }), React.createElement(Button, {
                              onClick: (function (param) {
                                  var selectedText = MM_wrk_editor.getSelectedText(state.cont);
                                  if (selectedText !== undefined) {
                                    Expln_utils_promise.promiseMap(MM_react_common.copyToClipboard(selectedText), (function (param) {
                                            Curry._1(setCopiedToClipboard, (function (timerId) {
                                                    if (timerId !== undefined) {
                                                      Common.$$clearTimeout(Caml_option.valFromOption(timerId));
                                                    }
                                                    return Caml_option.some(Common.$$setTimeout((function (param) {
                                                                      Curry._1(setCopiedToClipboard, (function (param) {
                                                                              
                                                                            }));
                                                                    }), 1000));
                                                  }));
                                          }));
                                    return ;
                                  }
                                  
                                }),
                              title: "Copy to the clipboard",
                              children: Caml_option.some(React.createElement(ContentCopy, {}))
                            }), React.createElement(Button, {
                              onClick: (function (param) {
                                  var selectedText = MM_wrk_editor.getSelectedText(state.cont);
                                  if (selectedText !== undefined) {
                                    return Curry._1(openExplorer, selectedText);
                                  }
                                  
                                }),
                              title: "Search in a new Explorer tab",
                              children: Caml_option.some(React.createElement(Search, {}))
                            }), React.createElement(Button, {
                              onClick: (function (param) {
                                  actUnselect(undefined);
                                }),
                              title: "Unselect, Esc",
                              children: Caml_option.some(React.createElement(CancelOutlined, {}))
                            })), Belt_Option.isSome(copiedToClipboard) ? "Copied to the clipboard." : null, MM_react_common.rndHiddenTextField(clickedTimeStr, (function (param) {
                            return MM_react_common.kbrdHnd3(partial_arg$2, partial_arg$1, partial_arg, param);
                          }), undefined));
        };
        var match$4 = state.cont;
        var textIsSelected;
        textIsSelected = match$4.TAG === /* Text */0 ? false : Belt_Option.isSome(match$4._0.clickedNodeId);
        var elems = [React.createElement("span", {
                style: {
                  fontFamily: "monospace",
                  fontSize: "1.3em"
                }
              }, MM_cmp_user_stmt.rndContText(state.cont, symRename, (function (idx) {
                      Curry._1(setSyntaxTreeWasRequested, (function (param) {
                              return idx;
                            }));
                    }), (function (idx) {
                      Curry._1(setSyntaxTreeWasRequested, (function (param) {
                              return idx;
                            }));
                    }), actTreeNodeClicked, actTreeNodeClicked, undefined, undefined, "pointer", true, undefined, undefined))];
        if (Belt_Option.isSome(syntaxTreeWasRequested)) {
          elems.push(React.createElement("span", undefined, "Building a syntax tree..."));
        }
        if (textIsSelected) {
          elems.push(rndSelectionButtons(undefined));
        }
        return React.createElement(Expln_React_Column.make, {
                    children: Caml_option.some(elems)
                  });
      }), propsAreSame);

exports.makeInitialState = makeInitialState;
exports.propsAreSame = propsAreSame;
exports.make = make;
/* make Not a pure module */
